import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { ToastService } from 'src/app/services/toast.service';
import { AppConstants } from 'src/app/utilities/constant';
import { LanguageSupportService } from '../../services/language-support.service';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';
import { isNotEmptyArray } from 'src/app/utilities/utils';
interface TemplateData {
  reportName: string;
  customerVersion: string;
  dateOfReport: string;
  displayDate?: string;
}

@Component({
  selector: 'app-report-version',
  templateUrl: './report-version.component.html',
  styleUrls: ['./report-version.component.scss'],
})
export class ReportVersionComponent implements OnInit {
  public templateData: TemplateData = {
    reportName: 'RA_Report_',
    customerVersion: 'V1',
    dateOfReport: new Date().toISOString().split('T')[0]
  };
  public formSubmitted = false;
  @Input() projectId: string; 
  @Input() projectStartDate: string;
  public formattedDate: string = '';
  @ViewChild('hiddenDateInput') hiddenDateInput!: ElementRef;
  public selectedLanguage: any;
  isDateofReportUpdatePermission: boolean = false;

  constructor(public popoverController: PopoverController,
    private confirmationService: ConfirmationService,
    private toastService: ToastService,
    private translate: TranslateService,
    private serviceMulti: LanguageSupportService,
    public userAuth: UserAuthService) { }

  ngOnInit() {
    this.checkPermissions();
    this.selectedLanguage = this.serviceMulti.getDefaultLanguage();
    this.templateData.reportName = this.templateData.reportName + this.projectId;
    this.formattedDate = this.formatDate(this.templateData.dateOfReport);
  }

  checkPermissions() {
    const user = this.userAuth.getUserList();
    if (user && isNotEmptyArray(user.permissions)) {
      const { permissions } = user;
      this.isDateofReportUpdatePermission = permissions.includes('DateofReport.Manage');      
    }
  }

  /**
   * Determines whether on cancel the form is valid.
   */
  async onCancel() {
    const isConfirmed = await this.confirmationService.presentConfirmationModal(
      this.translate.instant(AppConstants.ARE_YOU_SURE_TO_CANCEL),
      AppConstants.YES,
      true,
      this.translate.instant(AppConstants.CANCEL)
    );
    if (isConfirmed) {
      this.templateData = {
        reportName: '',
        customerVersion: '',
        dateOfReport: new Date().toISOString().split('T')[0]
      };
      this.formSubmitted = false;
      this.popoverController.dismiss(null, 'cancel');
    }
  }

  /**
   * Determines whether on submit the form is valid.
   */
  public onSubmit(): void {
    this.formSubmitted = true;

    if (this.templateData.reportName && this.templateData.reportName.trim()) {
      if (this.templateData.customerVersion === '' || !this.templateData.customerVersion || !this.templateData.customerVersion.trim()) {
        this.templateData.customerVersion = 'V1';
      } else {
        this.templateData.customerVersion = this.templateData.customerVersion.trim();
      }
      this.templateData.reportName += '.pdf';
      this.popoverController.dismiss(this.templateData, 'submit');
    }else {
      this.toastService.presentToast(this.translate.instant('Enter Report Name'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    }
  }

/**
 * Opens date picker
 */
public openDatePicker() {
  this.hiddenDateInput.nativeElement.showPicker();
}

/**
 * Determines whether date change on
 * 
 * @param event 
 */
public onDateChange(event: any) {
  this.templateData.dateOfReport = event.target.value;
  this.updateFormattedDate();
}

/**
 * Updates formatted date
 */
public updateFormattedDate() {
  if (this.templateData.dateOfReport) {
    this.formattedDate = this.formatDate(this.templateData.dateOfReport);
  } else {
    this.formattedDate = '';
  }
}

/**
 * Formats date
 * 
 * @param date 
 * @returns  
 */
private formatDate(date: string | Date) {
    if (!date) {
      return '';
    }

    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
      const [year, month, day] = date.split('T')[0].split('-');
      return `${day}-${this.getMonthAbbreviation(Number(month))}-${year}`;
    }

    const dateObj = new Date(date);
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = this.getMonthAbbreviation(dateObj.getMonth() + 1);
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  }

  private getMonthAbbreviation(month: number): string {
    const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    return monthNames[month - 1] || '';
  }
}
